<template>
  <v-card class="user-profile-card" flat tile :class="$vuetify.theme.dark ? 'blue-darken-5' : 'white-lighten-1'">
    <v-card-title>
      <v-icon class="pr-5" color="ash-lighten-4">mdi mdi-account-outline</v-icon>
      {{ profile?.fullname }}
    </v-card-title>
    <v-card-actions>
      <v-card-text class="py-0 pr-sm-0 flex-basic pl-sm-1">
        <v-avatar size="105">
          <v-img :src="profileImageUrl" :alt="profile?.profile_pic_url"></v-img>
        </v-avatar>
      </v-card-text>
      <v-card-text class="pa-0">
        <v-card-subtitle class="pa-0 mb-3">
          <span class="d-block">User ID </span>
          <span>{{ profile?.id }}</span>
        </v-card-subtitle>
        <v-card-subtitle class="pa-0">
          <span class="d-block">Email</span>
          <span>{{ profile?.email }}</span>
        </v-card-subtitle>
      </v-card-text>
    </v-card-actions>
  </v-card>
</template>

<script>
import { PROFILE__ACTIONS } from "@/store/action-types";
import { mapState, mapActions } from "vuex";

export default {
  data() {
    return {
      origin: ''
    };
  },

  computed: {
    ...mapState("profile", ["profile"]),
    profileImageUrl() {
      return this.profile?.profile_pic_url?.replace(origin, '') || '/acc-avatar.svg';
    }
  },

  methods: {
    ...mapActions("profile", [PROFILE__ACTIONS.PROFILE]),
  },

  async mounted() {
    await this[PROFILE__ACTIONS.PROFILE]();
    this.origin = window.location.origin
  },
};
</script>
